import { render } from "./TabelaBairroView.vue?vue&type=template&id=58317c61&scoped=true"
import script from "./TabelaBairroView.vue?vue&type=script&lang=js"
export * from "./TabelaBairroView.vue?vue&type=script&lang=js"

import "./TabelaBairroView.vue?vue&type=style&index=0&id=58317c61&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58317c61"]])

export default __exports__